import selecturl from './selecturl'
import Vue from 'vue'
let ui
const inited = false
export default {
  init() {
    const $selecturl = Vue.extend(selecturl)
    ui = new $selecturl()
    ui.$mount()
    document.body.appendChild(ui.$el)
    this.inited = true
  },
  select(event) {
    if (!inited) {
      this.init()
    }
    console.log(event)
    ui.success = event.success
    ui.show_select = true
  }
}
